import { create } from 'zustand';

import { DEFAULT_THEME_PREFERENCE } from './colorMode.constants';
import type { ResolvedTheme, ThemePreference } from './colorMode.constants';
import {
  getSystemPrefersDark,
  readStoredPreference,
  resolveTheme,
} from './colorMode.utils';

interface ThemeState {
  /** What the user picked: light, dark, or follow the OS. */
  preference: ThemePreference;
  /** Live `prefers-color-scheme: dark`, kept current by `ThemeSync`. */
  systemPrefersDark: boolean;
  setPreference: (preference: ThemePreference) => void;
  setSystemPrefersDark: (prefersDark: boolean) => void;
}

// Seeded from the localStorage mirror so the store agrees with whatever the
// inline script in index.html already painted.
export const useThemeStore = create<ThemeState>((set) => ({
  preference: readStoredPreference() ?? DEFAULT_THEME_PREFERENCE,
  systemPrefersDark: getSystemPrefersDark(),
  setPreference: (preference) => set({ preference }),
  setSystemPrefersDark: (systemPrefersDark) => set({ systemPrefersDark }),
}));

export const useThemePreferenceValue = () =>
  useThemeStore((state) => state.preference);

export const useResolvedTheme = (): ResolvedTheme =>
  useThemeStore((state) =>
    resolveTheme(state.preference, state.systemPrefersDark)
  );
